import menuManage from '@/views/setting/views/menuManage/menuManage';
export default menuManage;